import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import NavButton from "../components/NavButton";
import { useState } from "react";

function SpecialOffer() {
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        const formData = new FormData(e.target);

        const data = {
            firstname: formData.get("firstname"),
            lastname: formData.get("lastname"),
            company: formData.get("company"),
            email: formData.get("email"),
            phone: formData.get("phone"),
            message: formData.get("message"),
        };

        try {
            const response = await fetch("/api/contact", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Something went wrong.");
            }

            setSubmitted(true);
            e.target.reset();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className='page-wrapper'>
            <NavBar/>
            <main className='contact-div'>
                <h1>Request a Special Offer</h1>
                <hr/>
                {!submitted ? (
                    <div className='form-bg' style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                        <form id="contact-form" className='contact-form' onSubmit={handleSubmit}>
                            <div style={{display: 'flex', flexDirection: 'row', gap: '2rem'}}>
                                <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                                    <label style={{color: 'white'}}>First Name *</label>
                                    <input type="text" name="firstname" required style={{width: '100%'}}/>
                                </div>
                                <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                                    <label style={{color: 'white'}}>Last Name *</label>
                                    <input type="text" name="lastname" required style={{width: '100%'}}/>
                                </div>
                            </div>

                            <label>Company/Organization</label>
                            <input type="text" name="company"/>

                            <label>Email Address *</label>
                            <input type="email" name="email" required/>

                            <label>Phone Number</label>
                            <input type="tel" name="phone"/>

                            <label>Message *</label>
                            <textarea name="message" required style={{resize: 'none'}}/>

                            {error && <p style={{color: "red"}}>{error}</p>}

                            <button type='submit' disabled={loading}>
                                {loading ? "Sending..." : "Submit"}
                            </button>
                        </form>
                    </div>
                ) : (
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <p>Thank you for your inquiry.</p>
                        <p style={{textAlign: 'center'}}>Your message has been forwarded to our team.</p>
                        <NavButton text="View Our Work" width='40%' link="/gallery" height='200px'/>
                    </div>
                )}
            </main>
            <Footer/>
        </div>
    );
}

export default SpecialOffer;